import axios from 'axios';
import { Message,Loading } from 'element-ui';
var myaxios = {};
var aass = {};
// 这里域名使用配置文件/static/config.js

let base_url;
//配置开发环境
if (process.env.NODE_ENV === 'development') {
    // base_url = 'http://www.zhoaoss.com';
    base_url = window.Glob.DevErpApi;
}
// 配置生产环境
if (process.env.NODE_ENV === 'production') {
  // base_url = 'https://api.oa.gdzawy.com:9001';
  base_url = window.Glob.BuildErpApi;
}

myaxios.install = function(Vue){
    var axios_obj = axios.create({
        //请求接口
        baseURL:base_url
        // baseURL: 'http://www.zhoaoss.com',
        // baseURL: 'http://api.gdzawy.com:9000',
        // baseURL: 'http://api.51homemoney.com',
        // 获得this.$myhttp.defaults.baseURL
    })
    function onGetCall(config) {
        return config.method === 'get';
    }
    //发送请求前拦载
    axios_obj.interceptors.request.use(function (config) {
        var urlsa = config.url;
        var t = Date.parse(new Date()) / 1000;//时间戳
        var login = window.localStorage.getItem('login');
        var token = window.localStorage.getItem('token');
        var oa_user_id = window.localStorage.getItem('oa_user_id');
        if(urlsa.indexOf("?") != -1 ){
            config.url = config.url + "&datest="+t+"&login_name="+login+"&token="+token+"&oa_user_id="+oa_user_id
        }else{
            config.url = config.url + "?datest="+t+"&login_name="+login+"&token="+token+"&oa_user_id="+oa_user_id
        }
        return config;
    }, null, {
      // runWhen: onGetCall ,
    });

    // //发送请求返回拦载
    axios_obj.interceptors.response.use(function (response) {
        // 对响应数据做点什么
        var data = response.data;
        if(data == 206){
            alert('没有操作权限');
            var sxyc = window.localStorage.getItem('sxyc');
            window.localStorage.clear('login');//删除
            window.localStorage.clear('token');//删除
            if(sxyc != 66){
                // window.localStorage.setItem('sxyc',66);//刷新
                // location.reload();//刷新
                window.location.href = "/#/login";
            }
            return false;
        }
        if(data == 306){
            var sxyc = window.localStorage.getItem('sxyc');
            window.localStorage.clear('login');//删除
            window.localStorage.clear('token');//删除
            if(sxyc != 66){
              window.location.href = "/#/login";
              // window.localStorage.setItem('sxyc',66);//刷新
              // location.reload();//刷新
            }
            return false;
        }
        return response;
        },
        function (error) {
            // 对响应错误做点什么
            // console.log(cwul);
            return false;
        }
    );

  /**
   * 封装的请求基类方法
   * @param url 地址
   * @param method 请求类型
   * @param headers 头部信息
   * @param data 数据（post用）
   * @param params 数据（get用）
   * @param success 成功返回
   * @param error 失败返回
   * @constructor
   */
    axios_obj.Request=function ({url,method="GET",headers={},data={},params={},success,error}) {
      axios_obj({
        url:url,
        headers:headers,
        method:method,
        data:data,
        params:params,
      }).then(res=>{
        typeof success==="function"&&success(res.data);
      }).catch(e=>{
        typeof error==="function"&&error(e);
      })
    }

  /**
   * get封装请求
   * @param url 地址
   * @param data 数据
   * @param success 成功返回
   * @param error 失败返回
   */
  axios_obj.getRequest=function ({url,data},success,error) {
    axios_obj.Request({url,method:"GET",params:data,success,error})
  }

  /**
   * post请求
   * @param url 地址
   * @param data 数据
   * @param success 成功返回
   * @param error 失败返回
   */
  axios_obj.postRequest=function ({url,data},success,error) {
    axios_obj.Request({url,method:"POST",data:data,success,error})
  }
    window.__HTTP__=axios_obj;
    Vue.prototype.$myhttp = axios_obj;
}
export default myaxios;



// WEBPACK FOOTER //
// ./src/assets/js/http.js